import React, { useEffect, useRef, useState } from "react";
import "./HappyCustomersSlider.css";
import api from "../Api.js";
import ImageLightbox from "./Helping Component/ImageZoom";




export default function HappyCustomersSlider() {
const [lightboxOpen, setLightboxOpen] = useState(false);
const [currentImages, setCurrentImages] = useState([]);

  const sliderRef = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
      sliderRef.current.scrollBy({
        left: sliderRef.current.offsetWidth / 4,
        behavior: "smooth",
      });
    }, 3500);

    return () => clearInterval(interval);
  }, []);

  const nextSlide = () => {
    sliderRef.current.scrollBy({
      left: sliderRef.current.offsetWidth / 4,
      behavior: "smooth",
    });
  };

  const prevSlide = () => {
    sliderRef.current.scrollBy({
      left: -sliderRef.current.offsetWidth / 4,
      behavior: "smooth",
    });
  };

  const [galleryData, setGalleryData] = useState([]);
  useEffect(() => {
    const fetchGalleryData = async () => {
      try {
        const response = await api.get("/happy-customers");
        if (response.data.status) {
          // Assuming the API returns an array of image URLs
          const imagesFromApi = response.data.data;
          setGalleryData(imagesFromApi);
        }
      } catch (error) {
        console.error("Error fetching gallery data:", error);
      }
    };
    fetchGalleryData();
  }, []);

  const handleImages = (img) => {
    const galleryImages = galleryData?.[0]?.images?.map(item => item.url) || [];
    setCurrentImages([img?.url, ...galleryImages]);
    setLightboxOpen(true);
  }

  return (
    <section className="joyraj-happy-slider">
      <ImageLightbox
        open={lightboxOpen}
        setOpen={setLightboxOpen}
        images={currentImages}
      />
      <div className="joyraj-happy-header">
        <h2>Our Happy Customers</h2>
        <div className="joyraj-happy-controls">
          <button onClick={prevSlide}>‹</button>
          <button onClick={nextSlide}>›</button>
        </div>
      </div>

      <div className="joyraj-happy-track" ref={sliderRef}>
        {
          galleryData[0]?.images?.map((img, index) => (
            <div className="joyraj-happy-card" key={index} onClick={()=>handleImages(img)}>
              <img src={img?.url} alt="Happy Tour" />
            </div>
          ))}
      </div>
    </section>
  );
}
